// @flow
import React, { useState, useRef } from 'react'
import classnames from 'classnames'
import Link from 'next/link'

import { ApplyChangesButton } from '../applyChanges'
import { SidebarLogo } from './sidebarLogo/sidebarLogo'
import { SidebarPopup } from './sidebarPopup'
import { useOutsideClick } from '~/core/utils/hooks'
import { useGlobalContext } from '~/core/context'
import { useI18n } from '~/core/i18n'

import type { Page } from './types.flow'

type SidebarProps = {
  pages: Page[],
  url: string,
  onLogout?: () => void | Promise<void>
}

const Sidebar = ({ pages, url, onLogout }: SidebarProps) => {
  const [isPopupActive, setPopupActive] = useState(false)
  const { pbx, auth } = useGlobalContext()
  const [msg] = useI18n()
  const popupRef = useRef(null)

  const pbxHostname = pbx.hostname || ''
  const userEmail = auth.email || ''

  useOutsideClick(popupRef, () => setPopupActive(false), isPopupActive)

  const handleTogglePopup = () => setPopupActive(state => !state)

  return (
    <>
      <aside className="sidebar-app">
        {pages.length !== 0 && (
          <nav className="sidebar-app_nav">
            <div
              className={classnames('sidebar-app_nav_item sidebar-app_nav_item-w-status-pill', {
                active: isPopupActive
              })}
              id="popup-control"
              style={{
                padding: '15px'
              }}
              onClick={handleTogglePopup}
            >
              <figure className="avatar">
                <a title={`Přihlášen: ${userEmail} (${pbxHostname})`}>
                  <img className="img-fluid img-circle" src="/images/user_placeholder.png" />
                </a>
              </figure>
            </div>
            {pages
              .filter(page => page.isVisibleOnSidebar !== false)
              .map(({ title, path, name, subpages }) => (
                // $FlowFixMe
                <Link key={path} href={subpages ? Object.values(subpages)[0].path : path}>
                  <a
                    className={classnames('sidebar-app_nav_item', {
                      // Check if path starts with /<module_name>/ pattern
                      active: url.startsWith(path + '/')
                    })}
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      fontWeight: 'bold'
                    }}
                    title={msg(title || '')}
                  >
                    {name}
                  </a>
                </Link>
              ))}
            <ApplyChangesButton />
          </nav>
        )}
        <SidebarLogo />
      </aside>
      {isPopupActive && <SidebarPopup ref={popupRef} email={userEmail} msg={msg} onLogout={onLogout} />}
    </>
  )
}

export { Sidebar }
